import type { CurrentUser } from "~/slices/users/types";
import { useCurrentUser } from "~/slices/users/composables/api";

export const useCurrentUserStore = defineStore("currentUser", () => {
  const currentUser: Ref<CurrentUser | null> = ref(null);

  const fetchCurrentUser = async () => {
    const { data, suspense } = useCurrentUser();

    await suspense();

    if (data.value) {
      setCurrentUser(data.value);
    }
  };

  const setCurrentUser = (newUser: CurrentUser) => {
    currentUser.value = newUser;
  };

  const clearCurrentUser = () => {
    currentUser.value = null;
  };

  const isAuthenticated: Ref<boolean> = computed(() => {
    return !!currentUser.value;
  });

  const isShowPhoneNumber: Ref<boolean> = computed(() => {
    return !!currentUser.value?.is_shown_support_phone;
  });

  const isCardholder: Ref<boolean> = computed(() => {
    return !!currentUser.value?.cardholder;
  });

  const isTokenPresent: Ref<boolean> = computed(() => {
    const token = useCookie("token"); // Replace "token" with the actual name of your token cookie
    return !!token.value;
  });

  const isAdmin: Ref<boolean> = computed(() => {
    return !!currentUser.value?.admin;
  });

  return {
    currentUser,

    isTokenPresent,
    isAuthenticated,
    isShowPhoneNumber,
    isCardholder,
    isAdmin,

    fetchCurrentUser,
    setCurrentUser,
    clearCurrentUser,
  };
});
